module.exports = __webpack_public_path__ + "static/img/14000205.4356908b.png";